import * as Sentry from "@sentry/react";
import { trackHeader as track } from "~/events";
import { useAuthN } from "~/hooks/useAuthN";
import { useSessionsDestroyMutation } from "~/store/api";

interface Props {
  onClick?: () => void;
}

interface UseSignOut {
  handleSignOut: () => Promise<void>;
}

export const useSignOut = ({ onClick }: Props = {}): UseSignOut => {
  const [apiSessionsDestroy] = useSessionsDestroyMutation();
  const { handleUserSignOut } = useAuthN();

  const handleSignOut = async () => {
    track.signOutLink();
    onClick?.();

    try {
      await apiSessionsDestroy();
      handleUserSignOut();
    } catch (e: any) {
      Sentry.captureException(e);
    }
  };

  return { handleSignOut };
};
